import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import CallToAction from "../components/CallToAction";
import HomeBanner1 from "../ones/HomeBanner1";
import HomeGallerySection from "../ones/HomeGallerySection";
import HomeProductsSection from "../ones/HomeProductsSection";
import HomeServiceSection from "../ones/HomeServiceSection";
import Partners from "../ones/Partners";
import Footer from "../ones/Footer";

export default function View(props) {
  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..

    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <HomeBanner1 />
        <HomeServiceSection />
        <HomeProductsSection />
        <Partners />
        <HomeGallerySection />
        <CallToAction />
        <Footer />
      </>
    );
  } else {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }
}
